import { render, staticRenderFns } from "./bu.ativacao.vue?vue&type=template&id=b1584dfe&"
import script from "./bu.ativacao.vue?vue&type=script&lang=js&"
export * from "./bu.ativacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports